import { useQuery } from '@apollo/client/react'
import { ComboboxItem, ComboboxTagInput, ComboboxTagInputProps } from '@src/components/sco/ComboboxTagInput'
import { ScoInvestorTag } from '@src/graphql-types'
import { gql } from '@src/lib/gql'
import { useDebounce } from '@uidotdev/usehooks'
import { uniqBy } from 'lodash'
import React, { useEffect, useState } from 'react'

export const InvestorTagsComboboxInput = (props: {
  comboboxTagInputProps?: ComboboxTagInputProps
  defaultValue?: ComboboxItem[]
  value?: ComboboxItem[]
  onChange?: (investorTagItems: ComboboxItem[]) => any
  investorTagTypeKeys?: string[]
  deduplicateOptionsByTitle?: boolean
}) => {
  const [title, setTitle] = useState('')
  const debouncedTitle = useDebounce<string>(title, 250)
  const [investorTagOptions, setInvestorTagOptions] = useState<ScoInvestorTag[]>([])

  const query = useQuery(
    gql`
      query ($investorTagTypeKeys: [String], $title: String!, $limit: Int) {
        scoInvestorTags(
          investorTagTypeKeys: $investorTagTypeKeys
          title: $title
          limit: $limit
          order: [["popularity", "desc"]]
        ) {
          id
          investorTagId
          slug
          title
        }
      }
    `,
    {
      ssr: false,
      variables: {
        investorTagTypeKeys: props.investorTagTypeKeys,
        title: debouncedTitle,
        limit: 100,
      },
    }
  )

  useEffect(() => {
    if (query.data?.scoInvestorTags) {
      if (props.deduplicateOptionsByTitle) {
        setInvestorTagOptions(uniqBy(query.data.scoInvestorTags, t => t.title))
      } else {
        setInvestorTagOptions(query.data.scoInvestorTags)
      }
    }
  }, [query.data?.scoInvestorTags?.length, props.deduplicateOptionsByTitle])

  return (
    <ComboboxTagInput
      {...props.comboboxTagInputProps}
      defaultSelectedItems={props.defaultValue || []}
      value={props.value}
      itemsAreFiltered={true}
      itemsAreLoading={query.loading}
      items={investorTagOptions.map(investorTag => ({
        key: investorTag.investorTagId,
        title: investorTag.title,
      }))}
      onInputChange={value => setTitle(value)}
      onChange={(items: ComboboxItem[]) => {
        props.onChange?.(items)
      }}
    />
  )
}
